/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/destructuring-assignment */
import React from "react"
import UserService from "../services/user"

type State = { hasError: boolean }

class ErrorBoundary extends React.Component<any, State> {
    private static logout() {
        UserService.getInstance()
            .logout()
            .then(() => {
                window.location.reload()
            })
    }

    constructor(props: any) {
        super(props)
        this.state = { hasError: false } as any
    }

    static getDerivedStateFromError(): { hasError: boolean } {
        setTimeout(() => {
            // ErrorBoundary.logout()
        }, 3000)
        // Mettez à jour l'état, de façon à montrer l'UI de repli au prochain rendu.
        return { hasError: true }
    }

    componentDidCatch(error: unknown, errorInfo: unknown): void {
        // log
        // eslint-disable-next-line no-console
        console.error(error, errorInfo)
    }

    render() {
        if (this.state.hasError) {
            // Vous pouvez afficher n'importe quelle UI de repli.
            return (
                <>
                    <h3>
                        Une erreur s&apos;est produite lors du chargement de la
                        page.
                    </h3>
                    <strong>Redirection vers la page de login ...</strong>
                </>
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary
